<template>
    <modal
        name="create-permit-modal"
        :classes="'customModal'"
        :scrollable="true"
        :reset="true"
        :adaptive="false"
        :width="650"
        height="auto"
        @closed="closeModal()"
        @before-open="resetData"
    >
        <div class="modalWrapper">
            <div class="content__box">
                <div class="content__box__header">
                    <p class="text-white txt--ss opacity--50">Create Permit</p>
                </div>
                <div class="content__divider"></div>
                <div class="content__box__body">
                    <div class="form-group">
                        <label class="txt--xs txt--off-white mb-2"
                        >Permit name (required)</label
                        >
                        <input
                            type="text"
                            class="textInputField"
                            placeholder="Enter a permit name"
                            v-model.trim="permitName"
                        />
                    </div>
                    <div class="form-group">
                        <label class="txt--xs txt--off-white"
                        >Permit price (required)</label
                        >
                        <div class="input-group-prfix">
                            <span class="input-group-prefix-text">$</span
                            ><input
                                type="text"
                                placeholder="Enter permit price"
                                class="textInputField"
                                v-model.number="permitPrice"
                                @keypress="checkFloat"
                            />
                        </div>
                    </div>
                    <div class="form-group">
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <p class="txt--xs txt--off-white">Property (required)</p>
                            <!-- <app-toggle label="All properties" :checked="false"> </app-toggle> -->
                        </div>
                        <model-list-select
                            :list="propertyLists.filter(property => !additionalPropertyIds.includes(property.space_id))"
                            v-model="choosenPropertyId"
                            option-value="space_id"
                            option-text="property_name"
                            placeholder="Select property"
                            class="custom-vue-select"
                        >
                        </model-list-select>
                    </div>
                    <div class="form-group d-none">
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <p class="txt--xs txt--off-white">Additional properties (optional)
                                <i
                                    class="ml-2 far fa-question-circle"
                                    v-tooltip="'Allow permit to be used in multiple properties'">
                                </i>
                            </p>
                            <!-- <app-toggle label="All properties" :checked="false"> </app-toggle> -->
                        </div>
                        <multi-list-select
                            :list="propertyLists.filter(property => property.space_id !== choosenPropertyId)"
                            option-value="space_id"
                            option-text="property_name"
                            :selected-items="additionalProperties"
                            placeholder="Select additional properties"
                            :isDisabled=true
                            @select="didSelectAdditionalProperties"
                            class="custom-vue-select"
                        >
                        </multi-list-select>
                    </div>
                    <div class="form-group">
                        <label class="txt--xs txt--off-white mb-2">Required custom identifiers</label>
                        <multi-list-select
                            :list="requiredCustomIdentifierOptions"
                            option-value="value"
                            option-text="text"
                            :selected-items="selectedRequiredCustomIdentifiers"
                            placeholder="Select required identifier keys"
                            class="custom-vue-select"
                            :isDisabled="requiredCustomIdentifiersLoading"
                            @select="selectRequiredCustomIdentifiers"
                        >
                        </multi-list-select>
                        <p v-if="requiredCustomIdentifiersLoading" class="txt--xs txt--off-white opacity--50 mt-2 mb-0">
                            Loading available custom identifier keys...
                        </p>
                        <p v-else-if="!choosenPropertyId" class="txt--xs txt--off-white opacity--50 mt-2 mb-0">
                            Showing owner-level shared keys. Select a property to include property-specific keys.
                        </p>
                        <p v-else class="txt--xs txt--off-white opacity--50 mt-2 mb-0">
                            Showing owner-level shared keys plus keys specific to the selected property.
                        </p>
                        <p v-if="requiredCustomIdentifiersError" class="txt--xs txt--red mt-2 mb-0">
                            {{ requiredCustomIdentifiersError }}
                        </p>
                    </div>
                    <div class="form-group">
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <p class="txt--xs txt--off-white">
                                Number of permits available (required)
                            </p>

                            <app-toggle 
                            :checked="unlimited_permit"
                            :label="'Unlimited'"
                            @update:checked="getCheckedStatus($event, 'unlimited_permit')"> </app-toggle>
                        </div>
                        <input
                            type="text"
                            class="textInputField"
                            placeholder="Enter a permit name"
                            :disabled="unlimited_permit"
                            v-model.number="permitCount"
                            @keypress="checkNumber"
                        />
                    </div>
                    <div class="form-group">
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <p class="txt--xs txt--off-white">
                                Enforce vehicle count
                            </p>

                            <app-toggle
                            :checked="enforceVehicleCount"
                            :label="'Enforced'"
                            @update:checked="getCheckedStatus($event, 'enforce_vehicle_count')"> </app-toggle>
                        </div>
                        <div v-if="enforceVehicleCount">
                            <label class="txt--xs txt--off-white mb-2">Allowed vehicles</label>
                            <input
                                type="number"
                                min="1"
                                class="textInputField"
                                placeholder="Enter allowed vehicles"
                                v-model.number="enforcedVehicleCount"
                                @input="enforcedVehicleCountError = ''"
                            />
                        </div>
                        <p v-if="enforcedVehicleCountError" class="txt--xs txt--red mt-2 mb-0">
                            {{ enforcedVehicleCountError }}
                        </p>
                    </div>
                    <div class="form-group">
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <p class="txt--xs txt--off-white">
                                Enforce permit-wide vehicle limit
                            </p>

                            <app-toggle
                            :checked="enforcePermitVehicleLimit"
                            :label="'Enforced'"
                            @update:checked="getCheckedStatus($event, 'enforce_permit_vehicle_limit')"> </app-toggle>
                        </div>
                        <div v-if="enforcePermitVehicleLimit">
                            <label class="txt--xs txt--off-white mb-2">Maximum vehicles (permit-wide)</label>
                            <input
                                type="number"
                                min="1"
                                class="textInputField"
                                placeholder="e.g., 5"
                                v-model.number="permitVehicleLimit"
                                @input="permitVehicleLimitError = ''"
                            />
                        </div>
                        <p v-if="permitVehicleLimitError" class="txt--xs txt--red mt-2 mb-0">
                            {{ permitVehicleLimitError }}
                        </p>
                    </div>
                    <div class="form-group">
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <div>
                                <p class="txt--xs txt--off-white mb-0">Custom Identifier Vehicle Limits</p>
                                <p class="txt--xs txt--off-white opacity--50 mt-1 mb-0">
                                    Applies to matching subscribers, even if the permit-wide cap is off.
                                </p>
                            </div>
                            <a
                                href="javascript:void(0);"
                                class="txt--primary txt--xs"
                                @click="togglePermitCustomIdentifierLimitsSection"
                            >
                                {{ permitCustomIdentifierLimitsOpen ? 'Hide' : 'Show' }}
                            </a>
                        </div>
                        <div v-if="permitCustomIdentifierLimitsOpen">
                            <p v-if="permitCustomIdentifierOptionsLoading" class="txt--xs txt--off-white opacity--50 mt-2 mb-2">
                                Loading available custom identifier keys...
                            </p>
                            <p v-else-if="!choosenPropertyId" class="txt--xs txt--off-white opacity--50 mt-2 mb-2">
                                Showing owner-level shared keys. Select a property to include property-specific keys.
                            </p>
                            <p v-if="permitCustomIdentifierOptionsError" class="txt--xs txt--red mt-2 mb-2">
                                {{ permitCustomIdentifierOptionsError }}
                            </p>
                            <div
                                class="border-top pt-3 mt-3"
                                v-for="(limit, index) in permitCustomIdentifierVehicleLimits"
                                :key="`permit-custom-limit-${index}`"
                            >
                                <div class="form-row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="txt--xs txt--off-white mb-2">Key</label>
                                            <model-select
                                                :options="permitCustomIdentifierKeyOptions"
                                                class="custom-vue-select"
                                                v-model="limit.key"
                                                placeholder="Select a key"
                                                @input="onPermitCustomIdentifierVehicleLimitKeyChange(index, $event)"
                                            >
                                            </model-select>
                                            <p v-if="getPermitCustomIdentifierVehicleLimitFieldError(index, 'key')" class="txt--xs txt--red mt-2 mb-0">
                                                {{ getPermitCustomIdentifierVehicleLimitFieldError(index, 'key') }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="txt--xs txt--off-white mb-2">Value</label>
                                            <model-select
                                                v-if="isPermitCustomIdentifierPredefinedKey(limit.key)"
                                                :options="getPermitCustomIdentifierValueOptions(limit.key)"
                                                class="custom-vue-select"
                                                v-model="limit.value"
                                                placeholder="Select a value"
                                                @input="clearPermitVehicleLimitErrors"
                                            >
                                            </model-select>
                                            <input
                                                v-else
                                                type="text"
                                                class="textInputField"
                                                placeholder="Enter value"
                                                v-model.trim="limit.value"
                                                @input="clearPermitVehicleLimitErrors"
                                            />
                                            <p v-if="!isPermitCustomIdentifierPredefinedKey(limit.key) && limit.key" class="txt--xs txt--off-white opacity--50 mt-2 mb-0">
                                                {{ getPermitCustomIdentifierValueHint(limit.key) }}
                                            </p>
                                            <p v-if="getPermitCustomIdentifierVehicleLimitFieldError(index, 'value')" class="txt--xs txt--red mt-2 mb-0">
                                                {{ getPermitCustomIdentifierVehicleLimitFieldError(index, 'value') }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <div class="form-group">
                                            <label class="txt--xs txt--off-white mb-2">Max vehicles</label>
                                            <input
                                                type="number"
                                                min="1"
                                                class="textInputField"
                                                placeholder="Max vehicles"
                                                v-model.number="limit.max_vehicles"
                                                @input="clearPermitVehicleLimitErrors"
                                            />
                                            <p v-if="getPermitCustomIdentifierVehicleLimitFieldError(index, 'max_vehicles')" class="txt--xs txt--red mt-2 mb-0">
                                                {{ getPermitCustomIdentifierVehicleLimitFieldError(index, 'max_vehicles') }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-sm-1 d-flex align-items-center">
                                        <button
                                            type="button"
                                            class="btn btn-sm text-danger px-0"
                                            @click="removePermitCustomIdentifierVehicleLimit(index)"
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <p v-if="permitCustomIdentifierVehicleLimitsError" class="txt--xs txt--red mt-2 mb-2">
                                {{ permitCustomIdentifierVehicleLimitsError }}
                            </p>
                            <a
                                href="javascript:void(0);"
                                class="txt--primary txt--xs"
                                @click="addPermitCustomIdentifierVehicleLimit"
                            >
                                Add Custom Identifier Limit
                            </a>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="txt--xs txt--off-white mb-2 mr-2">Permit Types</label>
                        <ul class="top__filter__ul top__filter__ul--btn">
                            <li 
                                :class="{ active: payment === 'one-time' }"
                                @click="setPaymentType('one-time')"
                            >One-Time Permit</li>
                            <li
                                :class="{ active: payment === 'recurring' }"
                                @click="setPaymentType('recurring')"
                            >Recurring Permit</li>
                            <li
                                :class="{ active: payment === 'flex-recurring' }"
                                @click="setPaymentType('flex-recurring')"
                            >Flex Permit</li>
                        </ul>
                    </div>
                    <div class="form-group" v-if="payment == 'one-time'">
                        <label class="txt--xs txt--off-white mb-2 mr-2">Permit term</label>
                        <ul class="top__filter__ul top__filter__ul--btn">
                            <li :class="{ active: one_time_permit_type === 1 }"
                                @click="setOneTimePermitType(1)">Start & End Date</li>
                            <li :class="{ active: one_time_permit_type === 2 }"
                                @click="setOneTimePermitType(2)">Duration</li>
                        </ul>
                    </div>
                    <div class="form-row" v-if="payment == 'one-time' && one_time_permit_type === 1">
                        <div class="col-sm-5">
                            <div class="form-group">
                                <label class="txt--xs txt--off-white mb-2 mr-2"
                                >Start Date (required)</label
                                >
                                <VueDateTime
                                    title="Start Date"
                                    type="datetime"
                                    input-id="start_date"
                                    class="dateTime__picker"
                                    format="yyyy-MM-dd hh:mm a"
                                    :input-class="['textInputField']"
                                    :min-datetime="minDatetime"
                                    :max-datetime="permitEndDate"
                                    :value-zone="permitTimeZone"
                                    :zone="permitTimeZone"
                                    v-tooltip="permitTimeZone"
                                    v-model="permitStartDate"
                                    :clear-button="true"
                                    :disabled="permitTimeZone === ''"
                                    @close="checkDuration()"
                                ></VueDateTime>
                            </div>
                        </div>
                        <div class="col-sm-5">
                            <div class="form-group">
                                <label class="txt--xs txt--off-white mb-2 mr-2"
                                >End Date (required)</label
                                >
                                <VueDateTime
                                    title="End Date"
                                    type="datetime"
                                    input-id="end_date"
                                    class="dateTime__picker"
                                    format="yyyy-MM-dd hh:mm a"
                                    :input-class="['textInputField']"
                                    :min-datetime="permitStartDate"
                                    :value-zone="permitTimeZone"
                                    :zone="permitTimeZone"
                                    v-tooltip="permitTimeZone"
                                    v-model="permitEndDate"
                                    :clear-button="true"
                                    :disabled="permitTimeZone === ''"
                                    @close="checkDuration()"
                                ></VueDateTime>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="mt-4 pt-2" v-if="permitStartDate != '' || permitEndDate != ''"
                            >
                                <a
                                    href="javascript:void(0);"
                                    class="text-white txt--ss opacity--50"
                                    @click="
                                    permitStartDate = '';
                                    permitEndDate = '';
                                    "
                                >
                                    Clear
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" v-if="(payment == 'one-time' && one_time_permit_type == 2) || payment == 'recurring' || payment == 'flex-recurring'">
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label class="txt--xs txt--off-white mb-2"
                                >Permit Duration</label
                            >
                            <input
                                type="text"
                                @keypress="checkNumber()"
                                placeholder="Duration"
                                class="textInputField"
                                v-model.number="permitDuration"
                                @blur="checkDuration()"
                            />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                            <label class="txt--xs txt--off-white mb-2"
                                >Permit Duration Type</label
                            >
                            <model-select 
                                :options="duration_options"
                                class="custom-vue-select"
                                v-model="permitDurationType"
                                placeholder="Select Duration Type"
                            >
                            </model-select>
                            </div>
                        </div>
                    </div>
                    <div v-if="payment == 'flex-recurring'" class="form-group">
                        <label for="" class="txt--xs txt--off-white mb-2">Number of available parking days</label>
                        <input type="text" name="no_available_parking_days" id="available_parking_days" class="textInputField" @keypress="checkNumber" v-model="available_parking_days">
                    </div>
                    <div class="form-group" v-if="payment === 'recurring' || payment === 'flex-recurring'">
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <p class="txt--xs txt--off-white">
                                Require backdate on assignment
                            </p>

                            <app-toggle
                            :checked="backdateSubscriptionRequired"
                            :label="'Required'"
                            @update:checked="getCheckedStatus($event, 'backdateRequired')"> </app-toggle>
                        </div>
                        <div v-if="backdateSubscriptionRequired" class="mt-2">
                            <label class="txt--xs txt--off-white mb-2">Start date template</label>
                            <input
                                type="text"
                                class="textInputField"
                                placeholder="Y-m-01 00:00:00"
                                v-model.trim="backdateStartDateTemplate"
                                @input="backdateTemplateError = ''"
                            />
                            <p class="txt--xs txt--off-white opacity--50 mt-2 mb-1">
                                <strong>Format examples:</strong>
                            </p>
                            <ul class="txt--xs txt--off-white opacity--50 ml-3 mb-2">
                                <li><code>Y-m-d 00:00:00</code> = Today (2025-01-15 00:00:00)</li>
                                <li><code>Y-m-01 00:00:00</code> = First of current month (2025-01-01 00:00:00)</li>
                                <li><code>Y-01-01 00:00:00</code> = First of current year (2025-01-01 00:00:00)</li>
                                <li><code>monday this week</code> = Start of current week</li>
                            </ul>
                        </div>
                        <p v-if="backdateTemplateError" class="txt--xs txt--red mt-2 mb-0">
                            {{ backdateTemplateError }}
                        </p>
                    </div>
                    <div class="form-group">
                       <!--  <label class="txt--xs txt--off-white mb-2 mr-2"
                        >Days of the week</label
                        > -->
                        <div
                        class="
                            d-flex
                            align-items-center
                            justify-content-between
                            flex-wrap
                            mb-2
                        "
                        >
                            <p class="txt--xs txt--off-white">
                                Days of the week
                            </p>

                            <app-toggle 
                            :checked="activate_permit_timeslot"
                            :label="'TimeSlot'"
                            @update:checked="getCheckedStatus($event, 'activate_permit_timeslot')"> </app-toggle>
                        </div>
                        <ul class="top__filter__ul top__filter__ul--btn">
                            <li :class="[available_days.indexOf(7)!== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(7)">Sun</li>
                            <li :class="[available_days.indexOf(1)!== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(1)">Mon</li>
                            <li :class="[available_days.indexOf(2)!== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(2)">Tue</li>
                            <li :class="[available_days.indexOf(3)!== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(3)">Wed</li>
                            <li :class="[available_days.indexOf(4)!== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(4)">Thu</li>
                            <li :class="[available_days.indexOf(5)!== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(5)">Fri</li>
                            <li :class="[available_days.indexOf(6)!== -1 ? 'active' : '']" style="cursor: pointer" @click="availableDays(6)">Sat</li>
                            <li :class="[allDays ? 'active' : '']" style="cursor: pointer" @click="selectAlldays">All</li>
                        </ul>
                        <ul class="top__filter__ul mx-1" v-if="activate_permit_timeslot==true">
                            <li :class="[available_days.indexOf(7)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(7)">View</li>
                            <li :class="[available_days.indexOf(1)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(1)">View</li>
                            <li :class="[available_days.indexOf(2)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(2)">View</li>
                            <li :class="[available_days.indexOf(3)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(3)">View</li>
                            <li :class="[available_days.indexOf(4)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(4)">View</li>
                            <li :class="[available_days.indexOf(5)!== -1 ? 'active' : '']" class="mx-2" style="cursor: pointer" @click="viewDayTimeSlot(5)">View</li>
                            <li :class="[available_days.indexOf(6)!== -1 ? 'active' : '']" class="mx-1" style="cursor: pointer" @click="viewDayTimeSlot(6)">View</li>
                            <li :class="[allDays ? 'active' : '']" class="mx-1" style="cursor: pointer" @click="viewDayTimeSlot(8)">View</li>
                        </ul>
                    </div>
                    <div class="" id="permit_time_div" v-if="displayTimeFlag==true && activate_permit_timeslot==true">
                        
                        <div class="form-row mb-4">
                            <div class="col-sm-8">
                                <p class="txt--primary txt--semi-bold txt--ss">{{this.selectedDay?this.selectedDay:'Sunday'}}'s Time Slots</p>
                            </div>

                            <div class="col-sm-2">
                                <a
                                    href="javascript:void(0);"
                                    class="txt--primary txt--ss float-right"
                                    @click="
                                    addPermitTime()
                                    "
                                >
                                    Add More(+)
                                </a>
                            </div>
                        </div>
                        <div class="form-row" v-for='(permitTime, index) in permitTimesCurrent'  :key="index">
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="txt--xs txt--off-white mb-2 mr-2"
                                    >Start Time (required)</label
                                    >
                                    <VueDateTime
                                        title="Start Time"
                                        type="time"
                                        input-id="start_time"
                                        class="dateTime__picker"
                                        format="hh:mm a"
                                        :input-class="['textInputField']"
                                        v-tooltip="permitTimeZone"
                                        v-model="permitTime.permitStartTime"
                                        :zone="permitTimeZone"
                                        :clear-button="true"
                                        @close="checkDurationTime(permitTime)"
                                    ></VueDateTime>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-group">
                                    <label class="txt--xs txt--off-white mb-2 mr-2"
                                    >End Time (required)</label
                                    >
                                    <VueDateTime
                                        title="End Time"
                                        type="time"
                                        input-id="end_time"
                                        class="dateTime__picker"
                                        format="hh:mm a"
                                        :input-class="['textInputField']"
                                        v-tooltip="permitTimeZone"
                                        v-model="permitTime.permitEndTime"
                                        :zone="permitTimeZone"
                                        :clear-button="true"
                                        @close="checkDurationTime(permitTime)"
                                    ></VueDateTime>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="mt-4 pt-2"
                                >
                                    <a
                                        v-if="permitTime.permitStartTime != '' || permitTime.permitEndTime != ''"
                                        href="javascript:void(0);"
                                        class="text-white txt--ss opacity--50"
                                        @click="
                                        permitTime.permitStartTime = '';
                                        permitTime.permitEndTime = '';
                                        "
                                    >
                                        Clear
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-white txt--ss opacity--50 ml-4"
                                        @click="
                                        removePermitTime(index)
                                        "
                                    >
                                        Remove
                                    </a>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
                    <div class="mb-4">
                        <label class="txt--xs txt--off-white mb-2 mr-2">More options</label>
                        <div class="mb-2" v-if="payment == 'flex-recurring'">
                            <app-toggle 
                                :checked="flex_permit_onetime"
                                :label="'One time'"
                                @update:checked="getCheckedStatus($event, 'onetime')"
                            > 
                            </app-toggle>
                        </div>
                        <div class="mb-2">
                            <app-toggle 
                                :checked="freePermit"
                                :label="'Free Permit'"
                                @update:checked="getCheckedStatus($event, 'freePermit')"
                            >
                            </app-toggle>
                        </div>
                        <div class="mb-2">
                            <app-toggle 
                                :checked="fullAccess"
                                :label="'Full access'"
                                @update:checked="getCheckedStatus($event, 'fullAccess')"
                            > 
                            </app-toggle>
                        </div>
                        <div class="mb-2">
                            <app-toggle 
                            label="EV charging"
                            :checked="evCharging"
                            @update:checked="getCheckedStatus($event, 'evCharging')"
                            > 
                            </app-toggle>
                        </div>
                        <!-- <div class="mb-2">
                            <app-toggle label="Allow multiple vehicles" :checked="false"></app-toggle>
                        </div> -->
                        <div class="mb-2">
                            <app-toggle
                                :checked="handleType"
                                :label="'Manual payment method (not automated with Stripe)'"
                                @update:checked="getCheckedStatus($event, 'permitHandleType')"
                            ></app-toggle>
                        </div>
                        <div class="mb-2" >
                            <app-toggle
                                :checked="free_weekend_permit"
                                :label="'Free Weekend Parking'"
                                @update:checked="getCheckedStatus($event, 'freeWeekendPermit')"
                            ></app-toggle>
                        </div>
                        <div class="mb-2" >
                            <app-toggle
                                :checked="public_permit"
                                :label="'Public Permit'"
                                @update:checked="getCheckedStatus($event, 'publicPermit')"
                            ></app-toggle>
                        </div>
                    </div>
                    <div class="form-group mb-4 d-none">
                        <label class="txt--xs txt--off-white mb-2 mr-2"
                        >Availability/Visibility</label
                        >
                        <ul class="top__filter__ul top__filter__ul--btn">
                            <li class="active">Public (instant)</li>
                            <li>Private (manual)</li>
                        </ul>
                        <p class="txt--xs txt--off-white">
                        Permit appears available on the property’s public profile for
                        instant purchase
                        </p>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center flex-wrap mt-4">
                <ButtonWithSpinner
                class="button button--primary button--sm mr-3"
                :disabled="create_button.disabled"
                :loading="create_button.loading"
                :success="create_button.success"
                @click="createPermit"
                >
                Send</ButtonWithSpinner
                >
                <button
                    type="button"
                    class="button button--outline button--sm"
                    @click="closeModal()"
                >
                    Cancel
                </button>
            </div>
            <div class="session__modal__close" @click="closeModal()">
                <i class="fas fa-times"></i>
            </div>
        </div>
    </modal>
</template>
<script>
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect, ModelListSelect, MultiListSelect } from "vue-search-select";
import Toggle from "@/components/toggle";
import { Datetime as VueDateTime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import ButtonWithSpinner from "@/components/Button";
import {
    buildCustomIdentifierKeyOptions,
    buildSelectedCustomIdentifierKeys,
    extractApiErrorMessage,
    extractFieldErrors,
    fetchCustomIdentifierKeys,
    fetchPermitCustomIdentifierOptions,
    mergeCustomIdentifierKeyOptions,
    normalizePermitCustomIdentifierOptionsPayload,
    normalizePermitVehicleLimitEntry as normalizePermitVehicleCapEntry,
    normalizePermitVehicleLimitEntries as normalizePermitVehicleCapEntries,
    normalizePositiveInteger as normalizePositiveIntegerValue,
    normalizeRequiredCustomIdentifierKey,
    normalizeRequiredCustomIdentifiers,
} from "@/services/customIdentifier.service";

const __getEmptyTimeSlots = () => {
    return [
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //mon index-0
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //tue index-1
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //wed index-2
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //thu index-3
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //fri index-4
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //sat index-5
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //sun index-6
        [{permitStartTime:'',permitFormatedStartTime:'',permitEndTime:'',permitFormatedEndTime:''}], //all index-7                     
    ];
}

export default {
  name: "CreatePermit",
  components: {
    AppToggle: Toggle,
    VueDateTime,
    ModelListSelect,
    ModelSelect,
    MultiListSelect,
    ButtonWithSpinner
  },
  data() {
    return {
        propertyLists: [],
        permitName: "",
        permitPrice: null,
        permitCount: 1,
        payment: "one-time",
        permitStartDate: "",
        permitEndDate: "",
        //permitStartTime:"",
        //permitEndTime:"",
        permitTimeZone: "",
        permitTimes: __getEmptyTimeSlots(),
        permitTimesCurrent: {}, 
        activate_permit_timeslot:false, 
        dayOfWeekArr: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday","Allday"],    
        selectedDay:'',
        displayTimeFlag:false,
        minDatetime: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
        choosenPropertyId: null,
        additionalProperties: [],
        additionalPropertyIds: [],
        available_days: [],
        permitDurationType: "month",
        permitDuration: "",
        fullAccess: false,
        allDays:false,
        evCharging: false,
        handleType: false,
        unlimited_permit: false,
        one_time_permit_type:1,
        available_parking_days: 1,
        duration_options: [
            {value: '', text: 'Select Duration Type'},
            {value: 'day', text: 'Day'},
            {value: 'week', text: 'Week'},
            {value: 'month', text: 'Month'},
            {value: 'year', text: 'Year'},
        ],
        create_button: {
            disabled: false,
            loading: false,
            success: false,
        },
        free_weekend_permit: false,
        flex_permit_onetime:false,
        freePermit:         false,
        public_permit: false,
        requiredCustomIdentifierOptions: [],
        selectedRequiredCustomIdentifiers: [],
        requiredCustomIdentifiersLoading: false,
        requiredCustomIdentifiersError: "",
        backdateSubscriptionRequired: false,
        backdateStartDateTemplate: "",
        backdateTemplateError: "",
        enforceVehicleCount: false,
        enforcedVehicleCount: null,
        enforcedVehicleCountError: "",
        enforcePermitVehicleLimit: false,
        permitVehicleLimit: null,
        permitVehicleLimitError: "",
        permitCustomIdentifierLimitsOpen: false,
        permitCustomIdentifierVehicleLimits: [],
        permitCustomIdentifierVehicleLimitsError: "",
        permitCustomIdentifierVehicleLimitFieldErrors: {},
        permitCustomIdentifierOptionsLoading: false,
        permitCustomIdentifierOptionsError: "",
        permitCustomIdentifierKeyOptions: [],
        permitCustomIdentifierKeyDefinitions: {},
        permitCustomIdentifierValueOptions: {},
    };
  },
  watch: {
    permitPrice: function(val) {
      if(isNaN(val)) {
        this.permitPrice = null;
      }
    },
    permitDurationType: function(val) {
        if (this.backdateSubscriptionRequired) {
            const durationTemplates = {
                day: 'Y-m-d 00:00:00',
                week: 'monday this week',
                month: 'Y-m-01 00:00:00',
                year: 'Y-01-01 00:00:00'
            };
            this.backdateStartDateTemplate = durationTemplates[val] || '';
        }
    },
    choosenPropertyId: function(val) {
        if (val !== null) {
            this.permitTimeZone = this.getCurrentPermitTimezone();
            this.fetchRequiredCustomIdentifierOptions(val);
            this.fetchPermitCustomIdentifierVehicleLimitOptions(val);
        } else {
            this.fetchRequiredCustomIdentifierOptions("", true);
            this.fetchPermitCustomIdentifierVehicleLimitOptions("", true);
        }
    },
    permitStartDate: function(val) {
      let current_date = this.$moment().format("YYYY-MM-DD");
      let start_date = this.$moment(val).format("YYYY-MM-DD");
      let diff = this.$moment(start_date).diff(current_date, "days");

      if(diff > 365) {
        this.$toasted.show("Start date can not be more than 1 year ahead of current date!", {
          icon: "times-circle",
          className: "error-class",
        });
        this.permitStartDate = null;
      }
    },
    permitEndDate: function(val) {
      let start_date = this.permitStartDate ? this.$moment(this.permitStartDate).format("YYYY-MM-DD") : this.$moment().format("YYYY-MM-DD");
      let end_date = this.$moment(val).format("YYYY-MM-DD");
      let diff = this.$moment(end_date).diff(start_date, "days");

      if(diff > 365) {
        this.$toasted.show("Start date can not be more than 1 year ahead of current date!", {
          icon: "times-circle",
          className: "error-class",
        });
        this.permitEndDate = null;
      }
    },
  },
  created() {
      this.getAllproperty();
      this.permitTimesCurrent = this.permitTimes[6]; // sun day default
      console.log(">>>"+  this.permitTimes[6][0].permitStartTime);
      console.log("permitStartTime>>>"+  this.permitTimes[0][0].permitStartTime);
     
  },
  methods: {
    getEmptyTimeSlots() {
        return __getEmptyTimeSlots();
    },
    resetData() {
        this.permitName = "";
        this.allDays=false;
        this.payment = "one-time";
        this.one_time_permit_type = 1;
        this.permitStartDate = "";
        this.permitEndDate = "";
        this.permitCount = 1;
        this.evCharging = false;
        this.unlimited_permit = false;
        this.minDatetime = this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ");
        this.choosenPropertyId = null;
        this.additionalProperties = [];
        this.additionalPropertyIds = [];
        this.permitPrice = null;
        this.permitDurationType = "month";
        this.permitDuration = "";
        this.fullAccess = false;
        this.handleType = false;
        this.available_days = [];
        this.available_parking_days = 1;
        this.free_weekend_permit = false;
        this.freePermit = false;
        this.public_permit = false;
        this.create_button = {
            disabled: false,
            loading: false,
            success: false,
        };
        this.selectedDay='';       
        this.permitTimes = this.getEmptyTimeSlots();
        this.permitTimesCurrent= {}; 
        this.activate_permit_timeslot = false;
        this.displayTimeFlag = false;
        this.permitTimeZone = "";
        this.requiredCustomIdentifierOptions = [];
        this.selectedRequiredCustomIdentifiers = [];
        this.requiredCustomIdentifiersLoading = false;
        this.requiredCustomIdentifiersError = "";
        this.backdateSubscriptionRequired = false;
        this.backdateStartDateTemplate = "";
        this.backdateTemplateError = "";
        this.enforceVehicleCount = false;
        this.enforcedVehicleCount = null;
        this.enforcedVehicleCountError = "";
        this.enforcePermitVehicleLimit = false;
        this.permitVehicleLimit = null;
        this.permitVehicleLimitError = "";
        this.permitCustomIdentifierLimitsOpen = false;
        this.permitCustomIdentifierVehicleLimits = [];
        this.permitCustomIdentifierVehicleLimitsError = "";
        this.permitCustomIdentifierVehicleLimitFieldErrors = {};
        this.permitCustomIdentifierOptionsLoading = false;
        this.permitCustomIdentifierOptionsError = "";
        this.permitCustomIdentifierKeyOptions = [];
        this.permitCustomIdentifierKeyDefinitions = {};
        this.permitCustomIdentifierValueOptions = {};
        this.fetchRequiredCustomIdentifierOptions("", false);
        this.fetchPermitCustomIdentifierVehicleLimitOptions("", true);
    },
    normalizeRequiredCustomIdentifierKey(value) {
        return normalizeRequiredCustomIdentifierKey(value);
    },
    normalizeRequiredCustomIdentifiers(rawIdentifiers) {
        return normalizeRequiredCustomIdentifiers(rawIdentifiers);
    },
    buildRequiredCustomIdentifierSelection(keys) {
        return buildSelectedCustomIdentifierKeys(keys);
    },
    mergeRequiredCustomIdentifierOptions(options, selectedKeys) {
        return mergeCustomIdentifierKeyOptions(options, selectedKeys);
    },
    setSelectedRequiredCustomIdentifiersFromKeys(keys) {
        this.selectedRequiredCustomIdentifiers = this.buildRequiredCustomIdentifierSelection(keys);
    },
    getRequiredCustomIdentifierOptionsFromResponse(keys) {
        return buildCustomIdentifierKeyOptions(keys);
    },
    async fetchRequiredCustomIdentifierOptions(propertyId, preserveUnknownSelections = false) {
        const normalizedPropertyId = this.normalizeRequiredCustomIdentifierKey(propertyId);
        const selectedKeys = this.getRequiredCustomIdentifiersPayload();

        this.requiredCustomIdentifiersLoading = true;
        this.requiredCustomIdentifiersError = "";

        try {
            const keys = await fetchCustomIdentifierKeys(this.axios, window.hostname, normalizedPropertyId);
            const baseOptions = this.getRequiredCustomIdentifierOptionsFromResponse(keys);
            const nextOptions = preserveUnknownSelections
                ? this.mergeRequiredCustomIdentifierOptions(baseOptions, selectedKeys)
                : baseOptions;
            const availableKeys = nextOptions.map((option) => this.normalizeRequiredCustomIdentifierKey(option.value));
            const nextSelectedKeys = preserveUnknownSelections
                ? selectedKeys
                : selectedKeys.filter((key) => availableKeys.includes(key));

            this.requiredCustomIdentifierOptions = nextOptions;
            this.setSelectedRequiredCustomIdentifiersFromKeys(nextSelectedKeys);
        } catch (error) {
            this.requiredCustomIdentifierOptions = preserveUnknownSelections
                ? this.mergeRequiredCustomIdentifierOptions([], selectedKeys)
                : [];
            this.setSelectedRequiredCustomIdentifiersFromKeys(preserveUnknownSelections ? selectedKeys : []);
        } finally {
            this.requiredCustomIdentifiersLoading = false;
        }
    },
    selectRequiredCustomIdentifiers(items) {
        this.selectedRequiredCustomIdentifiers = Array.isArray(items) ? items : [];
        this.requiredCustomIdentifiersError = "";
    },
    getRequiredCustomIdentifiersPayload() {
        return this.normalizeRequiredCustomIdentifiers(this.selectedRequiredCustomIdentifiers);
    },
    normalizePermitVehicleLimitEntry(entry) {
        return normalizePermitVehicleCapEntry(entry);
    },
    getPermitCustomIdentifierVehicleLimitsPayload() {
        return normalizePermitVehicleCapEntries(this.permitCustomIdentifierVehicleLimits);
    },
    clearPermitVehicleLimitErrors() {
        this.permitVehicleLimitError = "";
        this.permitCustomIdentifierVehicleLimitsError = "";
        this.permitCustomIdentifierVehicleLimitFieldErrors = {};
    },
    applyPermitVehicleLimitErrors(errors) {
        const normalizedErrors = errors && typeof errors === "object" ? errors : {};
        this.clearPermitVehicleLimitErrors();
        this.permitVehicleLimitError = [
            ...(Array.isArray(normalizedErrors.enforce_permit_vehicle_limit) ? normalizedErrors.enforce_permit_vehicle_limit : []),
            ...(Array.isArray(normalizedErrors.permit_vehicle_limit) ? normalizedErrors.permit_vehicle_limit : []),
        ].join(" ");
        this.permitCustomIdentifierVehicleLimitsError = (
            Array.isArray(normalizedErrors.permit_custom_identifier_vehicle_limits)
                ? normalizedErrors.permit_custom_identifier_vehicle_limits
                : []
        ).join(" ");

        const fieldErrors = {};
        Object.keys(normalizedErrors).forEach((fieldName) => {
            if (fieldName.indexOf("permit_custom_identifier_vehicle_limits.") !== 0) {
                return;
            }

            fieldErrors[fieldName] = (Array.isArray(normalizedErrors[fieldName]) ? normalizedErrors[fieldName] : []).join(" ");
        });

        this.permitCustomIdentifierVehicleLimitFieldErrors = fieldErrors;
    },
    getPermitCustomIdentifierVehicleLimitFieldError(index, field) {
        return this.permitCustomIdentifierVehicleLimitFieldErrors[`permit_custom_identifier_vehicle_limits.${index}.${field}`] || "";
    },
    togglePermitCustomIdentifierLimitsSection() {
        this.permitCustomIdentifierLimitsOpen = !this.permitCustomIdentifierLimitsOpen;
    },
    addPermitCustomIdentifierVehicleLimit() {
        this.permitCustomIdentifierLimitsOpen = true;
        this.clearPermitVehicleLimitErrors();
        this.permitCustomIdentifierVehicleLimits.push({
            key: "",
            value: "",
            max_vehicles: null,
        });
    },
    removePermitCustomIdentifierVehicleLimit(index) {
        this.clearPermitVehicleLimitErrors();
        this.permitCustomIdentifierVehicleLimits.splice(index, 1);
    },
    getPermitCustomIdentifierSelectedKeys() {
        return this.getPermitCustomIdentifierVehicleLimitsPayload()
            .map((limit) => this.normalizeRequiredCustomIdentifierKey(limit.key))
            .filter((key) => key.length > 0);
    },
    getPermitCustomIdentifierDefinition(key) {
        const normalizedKey = this.normalizeRequiredCustomIdentifierKey(key);
        return (this.permitCustomIdentifierKeyDefinitions || {})[normalizedKey] || null;
    },
    isPermitCustomIdentifierPredefinedKey(key) {
        const definition = this.getPermitCustomIdentifierDefinition(key);
        return !!(definition && definition.value_type === "predefined");
    },
    getPermitCustomIdentifierValueOptions(key) {
        const normalizedKey = this.normalizeRequiredCustomIdentifierKey(key);
        return this.permitCustomIdentifierValueOptions[normalizedKey] || [];
    },
    getPermitCustomIdentifierValueHint(key) {
        const definition = this.getPermitCustomIdentifierDefinition(key);
        if (definition && definition.validation_message) {
            return definition.validation_message;
        }

        return "Enter the exact custom identifier value to match.";
    },
    onPermitCustomIdentifierVehicleLimitKeyChange(index, value) {
        if (!this.permitCustomIdentifierVehicleLimits[index]) {
            return;
        }

        const normalizedKey = this.normalizeRequiredCustomIdentifierKey(value);
        this.permitCustomIdentifierVehicleLimits[index].key = normalizedKey;
        this.permitCustomIdentifierVehicleLimits[index].value = "";
        this.clearPermitVehicleLimitErrors();
    },
    permitCustomIdentifierValueOptionExists(key, value) {
        const normalizedValue = this.normalizeRequiredCustomIdentifierKey(value).toLowerCase();
        if (!normalizedValue) {
            return false;
        }

        return this.getPermitCustomIdentifierValueOptions(key).some((option) => {
            return this.normalizeRequiredCustomIdentifierKey(option && option.value).toLowerCase() === normalizedValue;
        });
    },
    async fetchPermitCustomIdentifierVehicleLimitOptions(propertyId, preserveUnknownSelections = true) {
        const normalizedPropertyId = this.normalizeRequiredCustomIdentifierKey(propertyId);
        const selectedKeys = this.getPermitCustomIdentifierSelectedKeys();

        this.permitCustomIdentifierOptionsLoading = true;
        this.permitCustomIdentifierOptionsError = "";

        try {
            const payload = await fetchPermitCustomIdentifierOptions(this.axios, window.hostname, normalizedPropertyId);
            const normalizedPayload = normalizePermitCustomIdentifierOptionsPayload(payload);

            this.permitCustomIdentifierKeyDefinitions = normalizedPayload.keyDefinitions || {};
            this.permitCustomIdentifierValueOptions = normalizedPayload.valueOptions || {};
            this.permitCustomIdentifierKeyOptions = preserveUnknownSelections
                ? this.mergeRequiredCustomIdentifierOptions(normalizedPayload.keyOptions || [], selectedKeys)
                : (normalizedPayload.keyOptions || []);
        } catch (error) {
            this.permitCustomIdentifierKeyDefinitions = {};
            this.permitCustomIdentifierValueOptions = {};
            this.permitCustomIdentifierKeyOptions = preserveUnknownSelections
                ? this.mergeRequiredCustomIdentifierOptions([], selectedKeys)
                : [];
            this.permitCustomIdentifierOptionsError = "Custom identifier options could not be loaded. You can keep editing existing values manually.";
        } finally {
            this.permitCustomIdentifierOptionsLoading = false;
        }
    },
    validatePermitVehicleLimitConfiguration() {
        this.clearPermitVehicleLimitErrors();

        if (this.enforcePermitVehicleLimit) {
            const normalizedPermitVehicleLimit = normalizePositiveIntegerValue(this.permitVehicleLimit);
            if (!normalizedPermitVehicleLimit) {
                this.permitVehicleLimitError = "Permit vehicle limit must be a positive integer.";
                return {
                    valid: false,
                    message: this.permitVehicleLimitError,
                };
            }
        }

        const permitCustomIdentifierVehicleLimits = this.getPermitCustomIdentifierVehicleLimitsPayload();
        for (let index = 0; index < permitCustomIdentifierVehicleLimits.length; index += 1) {
            const limit = permitCustomIdentifierVehicleLimits[index];

            if (!limit.key) {
                const message = `Limit ${index + 1}: Key is required.`;
                this.permitCustomIdentifierVehicleLimitFieldErrors = {
                    ...this.permitCustomIdentifierVehicleLimitFieldErrors,
                    [`permit_custom_identifier_vehicle_limits.${index}.key`]: message,
                };
                return { valid: false, message };
            }

            if (!limit.value) {
                const message = `Limit ${index + 1}: Value is required.`;
                this.permitCustomIdentifierVehicleLimitFieldErrors = {
                    ...this.permitCustomIdentifierVehicleLimitFieldErrors,
                    [`permit_custom_identifier_vehicle_limits.${index}.value`]: message,
                };
                return { valid: false, message };
            }

            if (!limit.max_vehicles) {
                const message = `Limit ${index + 1}: Max vehicles must be a positive integer.`;
                this.permitCustomIdentifierVehicleLimitFieldErrors = {
                    ...this.permitCustomIdentifierVehicleLimitFieldErrors,
                    [`permit_custom_identifier_vehicle_limits.${index}.max_vehicles`]: message,
                };
                return { valid: false, message };
            }

            if (this.isPermitCustomIdentifierPredefinedKey(limit.key) && !this.permitCustomIdentifierValueOptionExists(limit.key, limit.value)) {
                const message = `Limit ${index + 1}: Please select an allowed value for ${limit.key}.`;
                this.permitCustomIdentifierVehicleLimitFieldErrors = {
                    ...this.permitCustomIdentifierVehicleLimitFieldErrors,
                    [`permit_custom_identifier_vehicle_limits.${index}.value`]: message,
                };
                return { valid: false, message };
            }
        }

        return { valid: true };
    },
    validateRequiredCustomIdentifiers() {
        const requiredCustomIdentifiers = this.getRequiredCustomIdentifiersPayload();

        for (const identifierKey of requiredCustomIdentifiers) {
            if (identifierKey.length > 64) {
                return {
                    valid: false,
                    message: `Required custom identifier keys cannot exceed 64 characters: ${identifierKey}`,
                };
            }
        }

        return { valid: true };
    },
    getCurrentPermitTimezone() {
      return this.propertyLists.filter((property) => {
        return this.choosenPropertyId == property.space_id;
      }).map((property) => {
        return property['time_zone'];
      })[0];
    },
    didSelectAdditionalProperties(items) {
      this.additionalProperties = items;
      this.additionalPropertyIds = items.map(item => item.space_id);

      console.debug(this.additionalPropertyIds);
    },
    selectAlldays(){
          this.allDays =!this.allDays;
          this.available_days=[];
          if(this.allDays==true){
            for(let i=1;i<8;i++){
                let every_day=i;
                this.available_days.push(every_day);
            }
            this.permitTimesCurrent = this.permitTimes[7];
            this.selectedDay = this.dayOfWeekArr[7];
            this.displayTimeFlag=true;
            console.log(this.available_days);
            console.log(this.allDays);
          }
          else{
                this.available_days=[];
                this.displayTimeFlag=false;

                for(let day_no=1;day_no<=8;day_no++)
                {
                    if(this.permitTimes[day_no-1].length>1){
                    
                        this.permitTimes[day_no-1].forEach((element,index) => {
                            this.$delete(this.permitTimes[day_no-1],index);
                        });
                    }
                    else{
                        this.permitTimes[day_no-1][0].permitStartTime='';
                        this.permitTimes[day_no-1][0].permitEndTime='';

                    }
                }
                console.log(this.available_days);
          }
    },
    checkNumber(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        }
        return true;
    },  
    checkFloat(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    }, 
    checkDuration() {
      if (
        (this.payment === "recurring") &
        (this.permitDuration !== "") &
        (this.permitStartDate !== "") &
        (this.permitEndDate !== "")
      ) {
        this.$toasted.show("Please select a date range or a duration!", {
          icon: "times-circle",
          className: "error-class",
        });
      }
    },
    checkDurationTime(permitTime){
        
        if(permitTime.permitEndTime!='')
       {      
            if((permitTime.permitStartTime>=permitTime.permitEndTime)|| permitTime.permitStartTime==''){
                this.$toasted.show("start time must be less than end time!", {
                        icon: "times-circle",
                        className: "error-class",
                    });
            }
       }
    },
    getCheckedStatus(checked, type) {
        if (type == "permitHandleType") {
        this.handleType = checked;
        } else if (type == "fullAccess") {
        this.fullAccess = checked;
        } else if(type == 'evCharging') {
            this.evCharging = checked;
        } else if(type == 'unlimited_permit') {
          this.unlimited_permit = checked;
          if(this.unlimited_permit) {
            this.permitCount = 0;
          }
        } else if(type == 'freeWeekendPermit') {
            this.free_weekend_permit = checked;
        }
        else if(type == 'onetime'){
            this.flex_permit_onetime =checked;
        } 
        else if(type == 'freePermit'){      
            this.freePermit = checked;
        }
        else if(type == 'activate_permit_timeslot') {
           
            this.activate_permit_timeslot = checked;
            if(this.activate_permit_timeslot==false){
              
                this.permitTimes = this.getEmptyTimeSlots();
                if (this.selectedDay!=='')
                {
                    let index_no = this.dayOfWeekArr.indexOf(this.selectedDay);
                    this.permitTimesCurrent={};
                    this.permitTimesCurrent=this.permitTimes[index_no];
                }
           
            }
        } else if (type === 'publicPermit') {
            this.public_permit = checked;
        } else if (type === 'backdateRequired') {
            this.backdateSubscriptionRequired = checked;
            this.backdateTemplateError = "";

            if (checked) {
                // Auto-populate template based on current duration type
                const durationTemplates = {
                    day: 'Y-m-d 00:00:00',
                    week: 'monday this week',
                    month: 'Y-m-01 00:00:00',
                    year: 'Y-01-01 00:00:00'
                };
                this.backdateStartDateTemplate = durationTemplates[this.permitDurationType] || '';
            } else {
                this.backdateStartDateTemplate = "";
            }
        } else if (type === 'enforce_vehicle_count') {
            this.enforceVehicleCount = checked;
            this.enforcedVehicleCountError = "";

            if (!checked) {
                this.enforcedVehicleCount = null;
            } else if (!this.enforcedVehicleCount || this.enforcedVehicleCount < 1) {
                this.enforcedVehicleCount = 1;
            }
        } else if (type === 'enforce_permit_vehicle_limit') {
            this.enforcePermitVehicleLimit = checked;
            this.permitVehicleLimitError = "";

            if (!checked) {
                this.permitVehicleLimit = null;
            }
        }
    },
    setPaymentType(paymentType) {
      if (paymentType == "recurring") {
        this.payment = paymentType;
        this.permitDuration = "";
        this.permitDurationType = 'month';
      }
      else if (paymentType == "one-time") {
        this.payment = paymentType;
        this.permitDuration = "";
        this.permitDurationType = "month";
        this.permitStartDate = "";
        this.permitEndDate = "";
        this.backdateSubscriptionRequired = false;
        this.backdateStartDateTemplate = "";
        this.backdateTemplateError = "";
      }
      else if(paymentType == 'flex-recurring') {
          this.payment = paymentType;
          this.permitDuration= "";
          this.permitDurationType = "month";
          this.permitStartDate = "";
          this.permitEndDate = "";
          this.available_parking_days = 1;
          //this.available_days = [1,2,3,4,5,6,7];
          //this.activate_permit_timeslot = false;
          //this.allDays = true;
      }
    }, 
    setOneTimePermitType(type) {
      this.one_time_permit_type = type;
      this.permitStartDate = '';
      this.permitEndDate = '';
      this.permitDuration = '';
      this.permitDurationType = 'month';
    },
    getAllproperty() {
      this.axios
        .post(window.hostname + "/api/auth/all-space", {
          device_type: 1,
          limit: 100,
          page: 1,
          search_param: "",
          space_type: 1,
          status: 4,
          minify: 1,
          minify_2: 1,
        })
        .then((res) => {
          if (res.data.status) {
            this.propertyLists = res.data.data.all_space;
            this.permitTimeZone = this.getCurrentPermitTimezone();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeModal() {
        this.resetData();
        this.$modal.hide("create-permit-modal");
    },
    availableDays(day) {
        if(this.available_days.indexOf(day)== -1) {
            this.available_days.push(day);
            if(this.available_days.length == 7){
                this.allDays=true;
                let day_no = 8;
                if(this.permitTimes[day_no-1].length>1){
                
                    this.permitTimes[day_no-1].forEach((element,index) => {
                        this.$delete(this.permitTimes[day_no-1],index);
                    });
                }
                else{
                    this.permitTimes[day_no-1][0].permitStartTime='';
                    this.permitTimes[day_no-1][0].permitEndTime='';

                }
                
            }
            this.permitTimesCurrent = this.permitTimes[day-1];
            this.selectedDay = this.dayOfWeekArr[day-1];
            this.displayTimeFlag=true;
        }
        else {
            let index = this.available_days.indexOf(day);
            this.$delete(this.available_days,index);
            this.allDays =false;
           
            if(this.permitTimes[day-1].length>1){
              
                this.permitTimes[day-1].forEach((element,index) => {
                    this.$delete(this.permitTimes[day-1],index);
                });
            }
            else{
                this.permitTimes[day-1][0].permitStartTime='';
                this.permitTimes[day-1][0].permitEndTime='';

            }
            
            this.permitTimesCurrent = this.permitTimes[day-1];
            this.selectedDay = '';
            this.displayTimeFlag=false;
        }
    },
    viewDayTimeSlot(day) {
        if((this.available_days.indexOf(day)== -1 && day!=8)||(this.allDays==false && day==8)){
            return;
        }
        this.permitTimesCurrent = this.permitTimes[day-1];
        this.permitTimesCurrent.sort(this.compareTime);
        this.selectedDay = this.dayOfWeekArr[day-1];
        this.displayTimeFlag=true;
    },
    compareTime(item1, item2) {
        const timeItem1 = item1.permitFormatedStartTime.split(':').map(Number);
        const timeItem2 = item2.permitFormatedStartTime.split(':').map(Number);

        if (timeItem1[0] < timeItem2[0]) {
            return -1;
        } else if (timeItem1[0] > timeItem2[0]) {
            return 1;
        } else {
            if (timeItem1[1] < timeItem2[1]) {
                return -1;
            } else if (timeItem1[1] > timeItem2[1]) {
                return 1;
            } else {
                return 0;
            }
        }
    },
     /**
     * Add Permit Time
     */
    addPermitTime() {

      this.permitTimesCurrent.push({permitStartTime:'',permitEndTime:''})

      var div = document.getElementById("permit_time_div");
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight - div.clientHeight;
      });
    },
    /**
     * Remove permit time
     */
    removePermitTime(index) {
      this.$delete(this.permitTimesCurrent, index);
    },
    validateTimeSlot(){

        var flag = true;

        let day_no=8;// all days
        let clone_done = false;
        //first check for the any valid start and end time available or not , if yes then clone the same data for all days
        if(this.allDays==true){

            let flag_blanck = true;
            if(this.permitTimes[day_no-1].length>0) 
            {
                    this.permitTimes[day_no-1].forEach((element,index) => {

                    let permitStartTimeNew = this.permitTimes[day_no-1][index].permitStartTime;
                    let permitEndTimeNew = this.permitTimes[day_no-1][index].permitEndTime;
                    if((permitStartTimeNew =='' && permitEndTimeNew !='')|| (permitStartTimeNew != '' && permitEndTimeNew ==''))
                    {                   
                        this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                            icon: "times-circle",
                            className: "error-class",
                        });
                        flag=false;                               
                    }
                    else if(permitStartTimeNew !='' && permitEndTimeNew !=''){

                        if (permitStartTimeNew>=permitEndTimeNew){
                            this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                                icon: "times-circle",
                                className: "error-class",
                            });
                            flag=false;
                        }
                    }else if(permitStartTimeNew =='' && permitEndTimeNew ==''){
                        if(this.permitTimes[day_no-1].length>1){
                            this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s start time and end time is not valid!", {
                                icon: "times-circle",
                                className: "error-class",
                            });
                            flag=false;
                        }
                        flag_blanck = false;
                    }
                    if(flag==false)
                    {
                        return;
                    }
                        
                });  
            }

            //copying array
            if(flag==true && flag_blanck==true && this.permitTimes[day_no-1].length>0){
                    for(let day_no_new=1;day_no_new<=7;day_no_new++){
                        let arr_length = this.permitTimes[day_no-1].length;
                        this.permitTimes[day_no_new-1]=[{}];
                        for(let index1=0;index1<arr_length;index1++){
                            this.permitTimes[day_no_new-1][index1].permitStartTime = this.permitTimes[day_no-1][index1].permitStartTime;
                            this.permitTimes[day_no_new-1][index1].permitEndTime = this.permitTimes[day_no-1][index1].permitEndTime;
                            if(index1<arr_length-1){
                                this.permitTimes[day_no_new-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                            }
                            clone_done=true;
                        }
                    }
            }
        } 

        if(clone_done==true){
            return true;
        }

        // convert null data to space for timeslot
        for(let day_no_new=1;day_no_new<=8;day_no_new++){
            let arr_length = this.permitTimes[day_no_new-1].length;
           
            if(arr_length==1){

                if(this.permitTimes[day_no_new-1][arr_length-1].permitStartTime==null){
                  this.permitTimes[day_no_new-1][arr_length-1].permitStartTime = '';
                }
                if(this.permitTimes[day_no_new-1][arr_length-1].permitFormatedStartTime==null){
                  this.permitTimes[day_no_new-1][arr_length-1].permitFormatedStartTime = '';
                }
                if(this.permitTimes[day_no_new-1][arr_length-1].permitEndTime==null){
                  this.permitTimes[day_no_new-1][arr_length-1].permitEndTime = '';
                }
                if(this.permitTimes[day_no_new-1][arr_length-1].permitFormatedEndTime==null){
                  this.permitTimes[day_no_new-1][arr_length-1].permitFormatedEndTime = '';
                }
            }
            // else if(arr_length==1){
            //    this.permitTimes[day_no_new-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
            // }
           
        } 

        for(let day_no=1;day_no<=8;day_no++)
        {             
            if(this.available_days.indexOf(day_no)!=-1 || (day_no==8 && this.allDays==true)) 
            {  
                if(this.permitTimes[day_no-1].length>0) 
                {
                    this.permitTimes[day_no-1].forEach((element,index) => {
                        //console.log(">>>>>>>>permitStartTime>>"+this.permitTimes[day_no-1][index].permitStartTime);
                        let permitStartTimeNew = this.permitTimes[day_no-1][index].permitStartTime;
                        let permitEndTimeNew = this.permitTimes[day_no-1][index].permitEndTime;
                        if((permitStartTimeNew =='' && permitEndTimeNew !='')|| (permitStartTimeNew != '' && permitEndTimeNew ==''))
                        {                   
                            this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                                icon: "times-circle",
                                className: "error-class",
                            });
                            flag=false;                               
                        }
                        else if(permitStartTimeNew !='' && permitEndTimeNew !=''){

                            if (permitStartTimeNew>=permitEndTimeNew){
                                this.$toasted.show(this.dayOfWeekArr[day_no-1]+"'s Start time must be less than end time!", {
                                    icon: "times-circle",
                                    className: "error-class",
                                });
                                flag=false;
                            }
                        }
                        if(flag==false)
                        {
                            return;
                        }
                            
                    });      
                }
                else{
                    this.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permitTimes[day_no-1][0].permitStartTime='';
                    this.permitTimes[day_no-1][0].permitEndTime='';
                }            
            }
            else{
                if(this.permitTimes[day_no-1].length>0){
                
                    this.permitTimes[day_no-1].forEach((element,index) => {
                        if(index>0)
                        {
                            this.$delete(this.permitTimes[day_no-1],index);
                        }
                    });
                    this.permitTimes[day_no-1][0].permitStartTime='';
                    this.permitTimes[day_no-1][0].permitEndTime='';
                }
                else{
                    this.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permitTimes[day_no-1][0].permitStartTime='';
                    this.permitTimes[day_no-1][0].permitEndTime='';

                }
            }
            if(flag==false)
            {
                return flag;
            }
        }
       
        return flag;
    },
    addFormatedTimes(){

        for(let day_no=1;day_no<=8;day_no++)
        {             
            if(this.available_days.indexOf(day_no)!=-1 || (day_no==8 && this.allDays==true)) 
            {  
                if(this.permitTimes[day_no-1].length>0) 
                {
                    this.permitTimes[day_no-1].forEach((element,index) => {
                        let permitStartTimeNew = this.permitTimes[day_no-1][index].permitStartTime;
                        let permitEndTimeNew = this.permitTimes[day_no-1][index].permitEndTime;
                        if(permitStartTimeNew !='' && permitEndTimeNew !=''){
                            this.permitTimes[day_no-1][index].permitFormatedStartTime = this.$moment(permitStartTimeNew).format("HH:mm");
                            this.permitTimes[day_no-1][index].permitFormatedEndTime = this.$moment(permitEndTimeNew).format("HH:mm");
                        }
                            
                    });      
                }
                else{
                    this.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permitTimes[day_no-1][0].permitStartTime='';
                    this.permitTimes[day_no-1][0].permitFormatedStartTime='';
                    this.permitTimes[day_no-1][0].permitEndTime='';
                    this.permitTimes[day_no-1][0].permitFormatedEndTime='';
                }            
            }
            else{
                if(this.permitTimes[day_no-1].length>0){
                
                    this.permitTimes[day_no-1].forEach((element,index) => {
                        if(index>0)
                        {
                            this.$delete(this.permitTimes[day_no-1],index);
                        }            
                    });
                    this.permitTimes[day_no-1][0].permitStartTime='';
                    this.permitTimes[day_no-1][0].permitFormatedStartTime='';
                    this.permitTimes[day_no-1][0].permitEndTime='';
                    this.permitTimes[day_no-1][0].permitFormatedEndTime='';
                }
                else{
                    this.permitTimes[day_no-1].push({'permitStartTime':'','permitFormatedStartTime':'','permitEndTime':'','permitFormatedEndTime':''});
                    this.permitTimes[day_no-1][0].permitStartTime='';
                    this.permitTimes[day_no-1][0].permitFormatedStartTime='';
                    this.permitTimes[day_no-1][0].permitEndTime='';
                    this.permitTimes[day_no-1][0].permitFormatedEndTime='';

                }
            }
        }
    },
    createPermit() {
                   
        if (this.permitName == "") {
            this.$toasted.show("Please provide a permit name!", {
                icon: "times-circle",
                className: "error-class",
            });
            return;
        }

        if(this.permitName.length > 64) {
            this.$toasted.show("Permit Name can not be more than 64 characters long!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }
        if(!window.regularExpressions.specialName.test(this.permitName)) {
            this.$toasted.show("Please provide a valid permit name!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }
        if(this.permitPrice <=0 && this.handleType == false) {
            this.$toasted.show("Permit price can not be 0 if handled by stripe!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }

        if(this.permitPrice > 10000) {
            this.$toasted.show("Permit price can not be more than $10000!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }
        if(!this.unlimited_permit && (this.permitCount <= 0 || this.permitCount == '')) {
            this.$toasted.show("Please provide a valid number of available permits!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }

        if (this.enforceVehicleCount && (!this.enforcedVehicleCount || this.enforcedVehicleCount < 1)) {
            this.enforcedVehicleCountError = "Allowed vehicles is required and must be at least 1 when enforcement is enabled.";
            this.$toasted.show(this.enforcedVehicleCountError, {
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }
        if (this.choosenPropertyId == null) {
            this.$toasted.show("Please select a property!", {
                icon: "times-circle",
                className: "error-class",
            });
            return;
        }

        if(this.available_days.length == 0) {
            this.$toasted.show("Please provide days at which the permit will be available!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }
        if(this.payment == 2 && this.available_parking_days<= 0) {
            this.$toasted.show("Number of available parking days can not be 0!",{
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        } 

        if(this.activate_permit_timeslot==true)
        {
            let validateTimeCheck = this.validateTimeSlot();
            if(validateTimeCheck==false){
                return;
            }
            this.addFormatedTimes();
        }

        const requiredCustomIdentifierValidation = this.validateRequiredCustomIdentifiers();
        if (!requiredCustomIdentifierValidation.valid) {
            this.$toasted.show(requiredCustomIdentifierValidation.message, {
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }

        const permitVehicleLimitValidation = this.validatePermitVehicleLimitConfiguration();
        if (!permitVehicleLimitValidation.valid) {
            this.$toasted.show(permitVehicleLimitValidation.message, {
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }

        const normalizedBackdateStartDateTemplate = this.backdateStartDateTemplate ? String(this.backdateStartDateTemplate).trim() : "";
        if (this.backdateSubscriptionRequired && !normalizedBackdateStartDateTemplate) {
            this.backdateTemplateError = "Backdate start date template is required when backdating is required.";
            this.$toasted.show(this.backdateTemplateError, {
                icon: 'times-circle',
                className: 'error-class'
            });
            return;
        }

        
        const permitFormData = {
            permit_name: this.permitName,
            permit_price: parseFloat(this.permitPrice),
            property_id: this.choosenPropertyId,
            property_id_list: this.additionalPropertyIds,
            recurring: this.payment === "recurring" ? 1 : this.payment == 'flex-recurring' && this.flex_permit_onetime ==false ? 2 : 0,
            // recurring: this.payment === "recurring" ? 1 : this.payment == 'flex-recurring' ? 2 : 0,
            available_parking_days: this.available_parking_days,
            public_permit: this.public_permit ? 1 : 0,
            permit_quantity: this.permitCount,
            handle_method: this.handleType ? "manual" : "stripe",
            available_days: this.available_days,
            available_days_timeslot: this.permitTimes,
            available_days_timeslot_status: this.activate_permit_timeslot==true?1:0,
            full_access: this.fullAccess ? 1 : 0,
            ev_charging: this.evCharging ? 1: 0,
            unlimited_permit: this.unlimited_permit? 1: 0,
            free_weekend_permit: this.free_weekend_permit ? 1 : 0,
            flex_permit_onetime:this.flex_permit_onetime ? 1 :0, 
            freePermit:this.freePermit ? 1 :0,
            required_custom_identifiers: this.getRequiredCustomIdentifiersPayload(),
            backdate_subscription: this.backdateSubscriptionRequired ? 1 : 0,
            backdate_start_date_template: this.backdateSubscriptionRequired ? normalizedBackdateStartDateTemplate : '',
            enforce_vehicle_count: this.enforceVehicleCount ? 1 : 0,
            enforced_vehicle_count: this.enforceVehicleCount ? parseInt(this.enforcedVehicleCount, 10) : null,
            enforce_permit_vehicle_limit: this.enforcePermitVehicleLimit ? 1 : 0,
            permit_vehicle_limit: this.enforcePermitVehicleLimit ? normalizePositiveIntegerValue(this.permitVehicleLimit) : null,
            permit_custom_identifier_vehicle_limits: this.getPermitCustomIdentifierVehicleLimitsPayload(),
        };

        if (this.payment === "recurring" || this.payment == 'flex-recurring') {
                let total_duration = this.permitDurationType == 'day' ? this.permitDuration : (this.permitDurationType == 'week' ? (this.permitDuration * 7) : (this.permitDurationType == 'month' ? this.permitDuration * 30 : (this.permitDurationType =="year" ? this.permitDuration*365 : this.permitDuration)));
                // console.log(total_duration); 
                if(this.available_parking_days > total_duration) {
                    this.$toasted.show("Number of available parking days can not be more than the permit duration!",{
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                    return;
                }
            if (!this.permitDuration || this.permitDuration == "") {
                this.$toasted.show("Permit Duration is required!", {
                    icon: "times-circle",
                    className: "error-class",
                });
                return;
            }
            if (this.permitDurationType == "") {
                this.$toasted.show("Permit Duration Type is required!", {
                    icon: "times-circle",
                    className: "error-class",
                });
                return;
            }
            if (
            (this.permitDuration > 365 && this.permitDurationType == "day") ||
            (this.permitDuration > 52 && this.permitDurationType == "week") ||
            (this.permitDuration > 12 && this.permitDurationType == "month") ||
            (this.permitDuration > 1 && this.permitDurationType == "year")
            ) {
                this.$toasted.show("Permit duration can not be more than 1 year!", {
                    icon: "times-circle",
                    className: "error-class",
                });
                return;
            }

            if(this.payment == 2) {
                let total_duration = this.permitDurationType == 'day' ? this.permitDuration : (this.permitDurationType == 'week' ? (this.permitDuration * 7) : (this.permitDurationType == 'month' ? this.permitDuration * 30 :(this.permitDurationType =="year" ? this.permitDuration*365 : this.permitDuration)));
                // console.log(total_duration); 
                if(this.available_parking_days > total_duration) {
                    this.$toasted.show("Number of available parking days can not be more than the permit duration!",{
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                    return;
                }
            }

            permitFormData.permit_duration = this.permitDuration;
            permitFormData.permit_duration_type = this.permitDurationType;
        } else if (this.payment === "one-time") {
            // If Nothing Is Selected
            if (
            this.permitStartDate == "" &&
            this.permitEndDate == "" &&
            this.permitDuration == "" &&
            this.permitDurationType == ""
            ) {
                this.$toasted.show("Please select a date range or a duration!", {
                    icon: "times-circle",
                    className: "error-class",
                });
                return;
            }
            // If Everything Is Selected
            if (
            this.permitStartDate != "" &&
            this.permitEndDate != "" &&
            this.permitDuration != "" &&
            this.permitDurationType != ""
            ) {
                this.$toasted.show("Please select a date range or a duration!", {
                    icon: "times-circle",
                    className: "error-class",
                });
                return;
            }

            if (this.permitDuration != "" && this.permitDurationType != "") {
                if ( (this.permitDuration > 365 && this.permitDurationType == "day") || (this.permitDuration > 52 && this.permitDurationType == "week") || (this.permitDuration > 12 && this.permitDurationType == "month") || (this.permitDuration > 1 && this.permitDurationType == "year")
                ) {
                    this.$toasted.show("Permit duration can not be more than 1 year!", {
                        icon: "times-circle",
                        className: "error-class",
                    });
                    return;
                }
                permitFormData.permit_duration = this.permitDuration;
                permitFormData.permit_duration_type = this.permitDurationType;
            } else {
                //Check If The Permit Start Date Is More Then 1 Year Ahead Of Current Time Or Not
                let current_date = this.$moment().format("YYYY-MM-DD");
                let start_date = this.$moment(this.permitStartDate).format(
                    "YYYY-MM-DD"
                );
                let end_date = this.$moment(this.permitEndDate).format("YYYY-MM-DD");
                let diffInDays = this.$moment(start_date).diff(current_date, "days");
                if (diffInDays >= 365) {
                    this.$toasted.show( "Start date can not be more than 1 year ahead of current date!", {
                        icon: "times-circle",
                        className: "error-class",
                    });
                    return;
                }

                //Check If The Duration Between Start Date And End Date Exceeds 1 Year Or Not
                let diffInEndDate = this.$moment(end_date).diff(start_date, "days");
                if (diffInEndDate > 365) {
                    this.$toasted.show("Permit with duration more than 1 year can not be created!",{
                        icon: "times-circle",
                        className: "error-class",
                    });
                    return;
                }

                // Available Days Validation If Start Date And End Date Has A Difference Of Less Than 7 Days
                let diff = this.$moment(end_date).diff(start_date,'days');
                if(diff<7) {
                    let temp_start = start_date;
                    let temp_end = end_date;
                    let day_array = [];
                    while(this.$moment(temp_end).diff(temp_start) >= 0) {
                        let day_of_week = parseInt(this.$moment(temp_start).format("E"));
                        day_array.push(day_of_week);

                        temp_start = this.$moment(temp_start).add(1,'days');
                    }

                    let day_diff = this.available_days.some(val=> day_array.indexOf(val) === -1);

                    if(day_diff) {
                        this.$toasted.show("Available days are invalid. Please provide vaild available days!",{
                            icon: 'times-circle',
                            className: 'error-class'
                        });
                        return;
                    }
                } 

                permitFormData.start_date = this.$moment(this.permitStartDate).tz(this.permitTimeZone).format("YYYY-MM-DDTHH:mm:ss.sssZ");
                permitFormData.end_date = this.$moment(this.permitEndDate).tz(this.permitTimeZone).format("YYYY-MM-DDTHH:mm:ss.sssZ");
            }
        }

        this.create_button.loading = true;
        this.create_button.disabled = true;
        this.create_button.success = false;
        this.axios
            .post(window.hostname + "api/auth/permit/create", permitFormData)
            .then((res) => {
                if (res.data.status) {
                    this.$toasted.show(res.data.message, {
                        icon: "check-circle",
                        className: "success-class",
                    });
                    this.$emit("update_list");
                    this.create_button.disabled = false;
                    this.create_button.success = true;
                    this.create_button.loading = false;
                    this.$emit("update_list");
                    this.closeModal();
                }
                else {
                    this.applyPermitVehicleLimitErrors(res.data.errors || {});
                    this.$toasted.show(res.data.message,{
                        icon : 'times-circle',
                        className: 'error-class'
                    });
                    this.create_button.disabled = false;
                    this.create_button.success = false;
                    this.create_button.loading = false;
                }
            })
            .catch((err) => {
                this.requiredCustomIdentifiersError = extractFieldErrors(err, 'required_custom_identifiers').join(' ');
                this.backdateTemplateError = extractFieldErrors(err, 'backdate_start_date_template').join(' ') || extractFieldErrors(err, 'backdate_subscription').join(' ');
                this.enforcedVehicleCountError = extractFieldErrors(err, 'enforced_vehicle_count').join(' ') || extractFieldErrors(err, 'enforce_vehicle_count').join(' ');
                this.applyPermitVehicleLimitErrors(err && err.response && err.response.data ? err.response.data.errors : {});
                this.create_button.disabled = false;
                this.create_button.success = false;
                this.create_button.loading = false;
                this.$toasted.show(extractApiErrorMessage(err),{
                    icon : 'times-circle',
                    className: 'error-class'
                });
            });
    },
  },
};
</script>

